import React from 'react';

const MAX_DATA_SIZE = 20000;

const TableExceedsDataSizeMessage = ({ dataSize }: { dataSize: number }): JSX.Element => {
    return dataSize > MAX_DATA_SIZE ? (
        <i className="table-exceeds-data-size-message">
            ** Results exceed maximum: 20,000 rows. Change filter values to limit results. **
        </i>
    ) : (
        <></>
    );
};

export default TableExceedsDataSizeMessage;
